import styled from "@emotion/styled";

export const Header = styled.h2`
    font-size: 1.5rem;
    margin: 2rem 0 -0.5rem 0;
`;
